<div>
  <div class="filter-container">
    <div>
      <div>{{ 'label.Year' | translate }}</div>
      <select [(ngModel)]="filter.year">
        <option [value]="-1" selected></option>
        <option *ngFor="let item of yearFilterOptions" [value]="item.value">
          {{ item.label }}
        </option>
      </select>
    </div>
    <div>
      <div>{{ 'label.Month' | translate }}</div>
      <select [(ngModel)]="filter.month" [disabled]="filter.year == -1">
        <option [value]="-1" selected></option>
        <option *ngFor="let item of monthFilterOptions" [value]="item.value">
          {{ item.label }}
        </option>
      </select>
    </div>
    <div>
      <div>{{ 'label.Day' | translate }}</div>
      <select
        [(ngModel)]="filter.day"
        [disabled]="!filter.month || filter.month == -1"
      >
        <option selected></option>
        <option *ngFor="let item of dayFilterOptions" [value]="item.value">
          {{ item.label }}
        </option>
      </select>
    </div>
    <div *ngIf="!isPortfolioStated">
      <div>{{ 'label.Portfolio' | translate }}</div>
      <select [(ngModel)]="filter.portfolioId">
        <option selected></option>
        <option *ngFor="let item of portfolios" [value]="item.portfolioId">
          {{ item.name }}
        </option>
      </select>
    </div>
    <div>
      <button class="apply" (click)="onFilter()">
        {{ 'label.Filter' | translate }}
      </button>
      <button class="clear" (click)="onClear()">
        {{ 'label.Clear' | translate }}
      </button>
    </div>
    <div style="float: right">
      <div>{{ 'label.Website' | translate }}</div>
      <select [(ngModel)]="filter.website" (change)="onFilter()">
        <option selected></option>
        <option *ngFor="let item of providerWebsiteList" [value]="item.value">
          {{ item.text }}
        </option>
      </select>
    </div>
  </div>
  <div class="tables">
    <div class="announcements-report" style="width: 600px; margin-bottom: 5em">
      <h3 style="display: inline-block">Announcements</h3>
      <h5 style="display: inline-block; margin-left: 42%">
        Total announcements:{{ reportData?.totalAnnouncements }}
      </h5>
      <p-table
        [value]="reportData.announcementsReportData"
        showGridlines
        [lazy]="true"
        (onLazyLoad)="onLoad($event)"
        [style]="{ 'text-align': 'center' }"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width: 60px; padding: 0">
              {{ 'label.Channel' | translate }}
            </th>
            <th style="width: 35px; padding: 0">Vip CV</th>
            <th style="width: 30px; padding: 0">Vip</th>
            <th style="width: 65px; padding: 0">Exclusive</th>

            <th style="padding: 0">Prio Prem.</th>

            <th style="padding: 0">Prio Stand.</th>

            <th style="width: 50px; padding: 0">Prio Start</th>

            <th style="padding: 0">Regular</th>

            <th style="padding: 0">Preview</th>

            <th style="font-weight: bold; width: 40px; padding: 0">
              {{ 'label.Total' | translate }}
            </th>

            <th style="font-weight: bold; width: 80px; padding: 0">
              {{ 'label.Sold' | translate }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-report let-columns="columns">
          <tr>
            <td>
              {{ report.channel }}
            </td>
            <td>
              {{ report.vipCV }}
            </td>
            <td>
              {{ report.vip }}
            </td>
            <td>
              {{ report.exclusive }}
            </td>
            <td>
              {{ report.prioPremium }}
            </td>
            <td>
              {{ report.prioStandard }}
            </td>
            <td>
              {{ report.prioStart }}
            </td>
            <td>
              {{ report.regular }}
            </td>
            <td>
              {{ report.regularPreview }}
            </td>
            <td>
              {{ reportData.getChannelTotal(report.channel, false) }}
            </td>
            <td>
              {{ reportData.getChannelTotal(report.channel, true) }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="footer" let-columns>
          <tr>
            <td style="font-weight: bold">
              {{ 'label.Total' | translate }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getAnnouncementsReportTotal('vipCV') }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getAnnouncementsReportTotal('vip') }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getAnnouncementsReportTotal('exclusive') }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getAnnouncementsReportTotal('premium') }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getAnnouncementsReportTotal('standard') }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getAnnouncementsReportTotal('start') }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getAnnouncementsReportTotal('regular') }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getAnnouncementsReportTotal('regularPreview') }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getChannelTotal(null, false) }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getChannelTotal(null, true) }}
            </td>
          </tr>
        </ng-template>

        <!-- <p-column header="{{'label.Channel' | translate}}">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{report.channel}}
            </ng-template>
            </p-column>
            <p-column header="Vip CV" [style]="{'width': '35px'}">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{report.vipCV}}
            </ng-template>
            </p-column>
            <p-column header="Vip" [style]="{'width': '35px'}">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{report.vip}}
            </ng-template>
            </p-column>
            <p-column header="Exclusive" [style]="{'padding': '0'}">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{report.exclusive}}
            </ng-template>
            </p-column>
            <p-column header="Prio Premium" [style]="{'padding': '0'}">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{report.prioPremium}}
            </ng-template>
            </p-column>
            <p-column header="Prio Standard" [style]="{'padding': '0'}">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{report.prioStandard}}
            </ng-template>
            </p-column>
            <p-column header="Prio Start">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{report.prioStart}}
            </ng-template>
            </p-column>
            <p-column header="Regular">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{report.regular}}
            </ng-template>
            </p-column>
            <p-column header="Preview">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{report.regularPreview}}
            </ng-template>
            </p-column>
            <p-column header="{{'label.Total' | translate}}" [style]="{'font-weight': 'bold', 'width': '45px'}">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{reportData.getChannelTotal(report.channel, false)}}
            </ng-template>
            </p-column>
            <p-column header="{{'label.Sold' | translate}}" [style]="{'font-weight': 'bold', 'width': '80px'}">
            <ng-template let-col let-report="rowData" pTemplate="body">
              {{reportData.getChannelTotal(report.channel, true)}}
            </ng-template>
            </p-column>
            <p-footerColumnGroup>
                <p-row>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{'label.Total' | translate}}"></p-column>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getAnnouncementsReportTotal('vipCV')}}"></p-column>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getAnnouncementsReportTotal('vip')}}"></p-column>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getAnnouncementsReportTotal('exclusive')}}"></p-column>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getAnnouncementsReportTotal('premium')}}"></p-column>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getAnnouncementsReportTotal('standard')}}"></p-column>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getAnnouncementsReportTotal('start')}}"></p-column>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getAnnouncementsReportTotal('regular')}}"></p-column>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getAnnouncementsReportTotal('regularPreview')}}"></p-column>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getChannelTotal(null, false)}}"></p-column>
                    <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getChannelTotal(null, true)}}"></p-column>
                </p-row>
            </p-footerColumnGroup> -->
      </p-table>
    </div>

    <div class="additional-product-report">
      <h3>Additionl Products</h3>
      <p-table
        *ngFor="let group of listAdditionalProductGroups()"
        showGridlines
        [value]="additionalProductTableData[group]"
        [style]="{
          'text-align': 'center',
          width: '300px',
          'margin-bottom': '10px'
        }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'label.Product' | translate }}</th>
            <th>{{ 'label.Count' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-report>
          <tr>
            <td>{{ report.product }}</td>
            <td style="font-weight: bold">{{ report.count }}</td>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="footer"
          *ngIf="group != AdditionalProductGroupEnum.Other.toString()"
        >
          <tr>
            <td style="font-weight: bold">{{ 'label.Total' | translate }}</td>
            <td style="font-weight: bold">
              {{ getAdditionalProductsTotal(group) }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="charts">
    <div class="large-chart">
      <p-chart
        type="bar"
        [data]="announcementReporChartData"
        *ngIf="announcementReporChartData != null"
      ></p-chart>
    </div>
    <div
      class="medium-chart"
      *ngIf="reportData.portfolioAdditionalProductsReportData.length > 0"
    >
      <h3>Logo</h3>
      <p-chart
        type="pie"
        [data]="logoReportChartData"
        *ngIf="logoReportChartData != null"
      ></p-chart>
    </div>
    <div
      *ngIf="reportData.portfolioAdditionalProductsReportData.length == 0"
      style="height: 450px"
    ></div>
  </div>
  <div class="full-width-charts">
    <div>
      <p-chart
        type="bar"
        [data]="frameReportChartData"
        *ngIf="frameReportChartData != null"
      ></p-chart>
    </div>
    <div>
      <p-chart
        type="bar"
        [data]="shareReportChartData"
        *ngIf="shareReportChartData != null"
      ></p-chart>
    </div>
  </div>
  <div>
    <h3>{{ 'label.Upgrade' | translate }}</h3>
    <div style="float: left">
      <p-table
        [value]="reportData.announcementUpgradesReportData"
        showGridlines
        [style]="{ 'text-align': 'center', width: '300px' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>
              {{ 'label.Type' | translate }}
            </th>
            <th style="font-weight: bold">
              {{ 'label.Count' | translate }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-report>
          <tr>
            <td>
              {{ report.name }}
            </td>
            <td>
              {{ report.totalSold }}
            </td>
          </tr>
        </ng-template>

        <!-- <p-column header="{{'label.Type' | translate}}">
            <ng-template let-col let-report="rowData" pTemplate="body">
                {{report.name}}
            </ng-template>
            </p-column>
            <p-column header="{{'label.Count' | translate}}" [style]="{'font-weight': 'bold'}">
            <ng-template let-col let-report="rowData" pTemplate="body">
                {{report.totalSold}}
            </ng-template>
            </p-column> -->
      </p-table>
      <button
        (click)="showDetailedUpgrades = !showDetailedUpgrades"
        style="float: right"
      >
        {{ 'label.Combinations' | translate }}
      </button>
    </div>
    <div style="display: inline-block; padding-left: 10%">
      <p-table
        *ngIf="showDetailedUpgrades"
        showGridlines
        [value]="reportData.upgradeCombinationsReportData"
        [lazy]="true"
        (onLazyLoad)="onUpgradesLoad($event)"
        [style]="{ 'text-align': 'center', 'max-width': '600px' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>
              {{ 'label.Combination' | translate }}
            </th>
            <th style="font-weight: bold; width: 100px">
              {{ 'label.Count' | translate }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-report>
          <tr>
            <td>
              {{ report.name }}
            </td>
            <td>
              {{ report.totalSold }}
            </td>
          </tr>
        </ng-template>

        <!-- <p-column header="{{'label.Combination' | translate}}">
            <ng-template let-col let-report="rowData" pTemplate="body">
                {{report.name}}
            </ng-template>
            </p-column>
            <p-column header="{{'label.Count' | translate}}" [style]="{'font-weight': 'bold', 'width': '100px'}">
            <ng-template let-col let-report="rowData" pTemplate="body">
                {{report.totalSold}}
            </ng-template>
            </p-column> -->
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              {{ 'message.' + getEmptyMessageResourceName() | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <br />
  <div class="tables" style="clear: both">
    <div class="cv-db-report medium-table">
      <h3>CV Database</h3>
      <p-table [value]="reportData.cvDatabasesReportData" showGridlines>
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 120px">
              {{ 'label.Product' | translate }}
            </th>
            <th style="font-weight: bold">
              {{ 'label.Free' | translate }}
            </th>
            <th style="font-weight: bold">
              {{ 'label.Sold' | translate }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-report>
          <tr>
            <td>{{ report.name }}</td>
            <td>{{ report.totalFree }}</td>
            <td>{{ report.totalSold }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="footer">
          <tr>
            <td style="font-weight: bold">{{ 'label.Total' | translate }}</td>
            <td style="font-weight: bold">
              {{ reportData.getCvDbTotal(true) }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getCvDbTotal(false) }}
            </td>
          </tr>
        </ng-template>

        <!-- <p-column header="{{'label.Product' | translate}}" [style]="{'width': '120px'}">
          <ng-template let-col let-report="rowData" pTemplate="body">
            {{report.name}}
          </ng-template>
        </p-column>
        <p-column header="{{'label.Free' | translate}}" [style]="{'font-weight': 'bold'}">
          <ng-template let-col let-report="rowData" pTemplate="body">
            {{report.totalFree}}
          </ng-template>
        </p-column>
        <p-column header="{{'label.Sold' | translate}}" [style]="{'font-weight': 'bold'}">
          <ng-template let-col let-report="rowData" pTemplate="body">
            {{report.totalSold}}
          </ng-template>
        </p-column>
        <p-footerColumnGroup>
          <p-row>
            <p-column [style]="{'font-weight': 'bold'}" footer="{{'label.Total' | translate}}"></p-column>
            <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getCvDbTotal(true)}}"></p-column>
             <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getCvDbTotal(false)}}"></p-column>
          </p-row>
        </p-footerColumnGroup> -->
      </p-table>
    </div>
    <div class="slider-banner-report medium-table">
      <h3>Slider</h3>
      <p-table
        [value]="reportData.sliderBannersReportData"
        showGridlines
        [style]="{ 'text-align': 'center' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>
              {{ 'label.Channel' | translate }}
            </th>
            <th style="font-weight: bold">
              {{ 'label.Free' | translate }}
            </th>
            <th style="font-weight: bold">
              {{ 'label.Sold' | translate }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-report>
          <tr>
            <td>
              {{ report.name }}
            </td>
            <td>
              {{ report.totalFree }}
            </td>
            <td>
              {{ report.totalSold }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="footer">
          <tr>
            <td style="font-weight: bold">
              {{ 'label.Total' | translate }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getSliderTotal(true) }}
            </td>
            <td style="font-weight: bold">
              {{ reportData.getSliderTotal(false) }}
            </td>
          </tr>
        </ng-template>

        <!-- <p-column header="{{'label.Channel' | translate}}">
                <ng-template let-col let-report="rowData" pTemplate="body">
                {{report.name}}
                </ng-template>
                </p-column>
                <p-column header="{{'label.Free' | translate}}" [style]="{'font-weight': 'bold'}">
                <ng-template let-col let-report="rowData" pTemplate="body">
                {{report.totalFree}}
                </ng-template>
                </p-column>
                <p-column header="{{'label.Sold' | translate}}" [style]="{'font-weight': 'bold'}">
                <ng-template let-col let-report="rowData" pTemplate="body">
                {{report.totalSold}}
                </ng-template>
                </p-column>
                <p-footerColumnGroup>
                    <p-row>
                        <p-column [style]="{'font-weight': 'bold'}" footer="{{'label.Total' | translate}}"></p-column>
                        <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getSliderTotal(true)}}"></p-column>
                        <p-column [style]="{'font-weight': 'bold'}" footer="{{reportData.getSliderTotal(false)}}"></p-column>
                    </p-row>
                </p-footerColumnGroup> -->
      </p-table>
    </div>
  </div>
  <div class="charts">
    <div class="medium-chart">
      <p-chart
        type="bar"
        [data]="cvDbReportChartData"
        *ngIf="cvDbReportChartData != null"
      ></p-chart>
    </div>
    <div class="medium-chart">
      <p-chart
        type="bar"
        [data]="sliderReportChartData"
        *ngIf="sliderReportChartData != null"
      ></p-chart>
    </div>
  </div>
</div>
